import { mergeProps as _mergeProps, createTextVNode as _createTextVNode, createVNode as _createVNode } from "vue";
export default {
  name: 'BrainIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return _createVNode("svg", _mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brain",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [_createTextVNode("   "), _createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M15.5 13a3.5 3.5 0 0 0 -3.5 3.5v1a3.5 3.5 0 0 0 7 0v-1.8"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M8.5 13a3.5 3.5 0 0 1 3.5 3.5v1a3.5 3.5 0 0 1 -7 0v-1.8"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M17.5 16a3.5 3.5 0 0 0 0 -7h-.5"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M19 9.3v-2.8a3.5 3.5 0 0 0 -7 0"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M6.5 16a3.5 3.5 0 0 1 0 -7h.5"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M5 9.3v-2.8a3.5 3.5 0 0 1 7 0v10"
    }, null), _createTextVNode(" ")]);
  }
};